module.exports = __webpack_public_path__ + "static/colorpickercontrast-566fdba7f69d1b772cdd78fba1cc9022.mp4";